// src/sectors/pilates/reports/api/reportsApi.js
import { http } from 'shared/api/http';

export const reportsApi = {
  memberBoard({ q, limit = 20 } = {}) {
    const qs = new URLSearchParams();
    if (q) qs.set('q', q);
    if (limit != null) qs.set('limit', String(limit));

    return http(`/api/v1/pilates/reports/members/board?${qs.toString()}`, {
      method: 'GET',
    }).then((r) => (Array.isArray(r) ? r : []));
  },
  memberTimeline({ memberId, from, to, limit = 200 } = {}) {
    if (!memberId) return Promise.resolve([]);

    const qs = new URLSearchParams();
    if (from) qs.set('from', from);
    if (to) qs.set('to', to);
    if (limit != null) qs.set('limit', String(limit));

    return http(`/api/v1/pilates/sessions/member/${memberId}/timeline?${qs.toString()}`, {
      method: 'GET',
    }).then((r) => (Array.isArray(r) ? r : []));
  },
  activityLogsByDate({
    from,
    to,
    trainerId = null,
    memberId = null,
    channel = 'UI', // ✅ eklendi
    page = 0,
    size = 50,
  } = {}) {
    const qs = new URLSearchParams({
      from,
      to,
      channel, // ✅ eklendi
      page: String(page),
      size: String(size),
    });

    if (trainerId != null) qs.set('trainerId', String(trainerId));
    if (memberId != null) qs.set('memberId', String(memberId));

    const url = `/api/v1/pilates/reports/activity-logs/by-date?${qs.toString()}`;
    console.log('🟢 [reportsApi.activityLogsByDate] GET', url);

    return http(url, { method: 'GET' });
  },
  // Trainer session history
  listTrainerSessions({ trainerId, from, to, limit = 200 } = {}) {
    console.group('🟢 [reportsApi.listTrainerSessions]');
    console.log('trainerId:', trainerId);
    console.log('from:', from);
    console.log('to:', to);
    console.log('limit:', limit);
    console.groupEnd();

    if (!trainerId) return Promise.resolve([]);

    const qs = new URLSearchParams();
    if (from) qs.set('from', from);
    if (to) qs.set('to', to);
    if (limit) qs.set('limit', String(limit));

    const url = `/api/v1/pilates/reports/trainers/${trainerId}/sessions?${qs.toString()}`;

    return http(url, { method: 'GET' }).then((r) => {
      console.log('🟢 [reportsApi.listTrainerSessions] response:', r);
      return Array.isArray(r) ? r : [];
    });
  },
  // Trainer overview (KPI + pie + trend + actions + rating)
  getTrainerOverview({ trainerId, from, to } = {}) {
    console.group('🟣 [reportsApi.getTrainerOverview]');
    console.log('trainerId:', trainerId);
    console.log('from:', from);
    console.log('to:', to);
    console.groupEnd();

    if (!trainerId) return Promise.resolve(null);

    const qs = new URLSearchParams();
    if (from) qs.set('from', from);
    if (to) qs.set('to', to);

    const url = `/api/v1/pilates/reports/trainers/${trainerId}/overview?${qs.toString()}`;
    console.log('🟣 [reportsApi.getTrainerOverview] GET', url);

    return http(url, { method: 'GET' }).then((r) => {
      console.log('🟣 [reportsApi.getTrainerOverview] response:', r);
      return r || null;
    });
  },
};
